module.exports = {"data":{"site":{"siteMetadata":{"title":"Owla ja kadonnut walkia"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 89
// module chunks = 60335399758886 114276838955818